<template>
    <form 
        role="form" 
        class="row" 
        @submit.prevent="submit">
        <div class="col-sm-6">
            <div class="form-group">
                <label for="name">Ime</label>
                <input 
                    id="name"
                    v-model="rowData.name"
                    type="text"
                    class="form-control"
                    name="name"
                    placeholder="ime">
            </div>
            <div class="form-group">
                <label for="email">E-pošta</label>
                <input 
                    id="email"
                    v-model="rowData.email"
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="e-pošta">
            </div>
            <div class="checkbox">
                <label>
                    <input 
                        v-model="rowData.admin" 
                        type="checkbox">
                    <b>Skrbnik</b>
                </label>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label for="password">Geslo</label>
                <input 
                    id="password"
                    :pattern="'.{' + minimum_password_length + ',}'"
                    v-model="password"
                    type="password"
                    class="form-control"
                    name="password"
                    placeholder="Geslo">
            </div>
            <div class="form-group">
                <label for="password_confirmation">Ponovi geslo</label>
                <input 
                    id="password_confirmation"
                    :pattern="'.{' + minimum_password_length + ',}'"
                    v-model="passwordConfirmation"
                    type="password"
                    class="form-control"
                    name="password_confirmation"
                    placeholder="Ponovi geslo">
            </div>
        </div>
        <div class="col-sm-12">
            <button 
                type="submit"
                class="btn btn-success">
                Posodobi
            </button>
        </div>
    </form>
</template>

<script>
import TableDetails from '../../mixins/TableDetails';

export default {
    name: 'UserDetails',

    mixins: [
        TableDetails
    ],

    data() {
        return {
            apiUrl:                  '/ajax/users',
            minimum_password_length: 6,
            password:                null,
            passwordConfirmation:    null
        };
    },

    methods: {
        prepareUpdateData() {
            let data = (({email, name, admin}) => ({email, name, admin}))(this.rowData);

            if (this.password && this.password.length) {
                if (this.password === this.passwordConfirmation) {
                    data['password'] = this.password;
                    data['password_confirm'] = this.passwordConfirmation;
                } else {
                    this.$toast.error({
                        title:   'NAPAKA!',
                        message: 'Gesli se morata ujemati!',
                        timeOut: 10000
                    });

                    return {};
                }
            }

            return data;
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Users/UserDetails.vue